import { css } from 'styled-components';

export default css`
  padding-bottom: 24px;
  padding-top: 12px;
  .comment {
    textarea {
      width: 85%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .comment-footer {
    text-align: right;
  }

  .actions {
    padding-top: 42px;
    @media (max-width: 410px) {
      margin-top: 52px;
    }
     @media (min-width: 411px) {
      float: right;
      padding: 42px 0 20px 0;
    }
  }

  .recipients {
    margin: 42px 0 0 38vw;
    @media (max-width: 800px) {
      margin-left: 30vw;
    }
    @media (max-width: 650px) {
      margin: 100px 0 0 0;
    }
    @media (max-width: 410px) {
      margin-top: 20px;
    }

    span {
      padding-top: 8px;
    }

    .iconValid {
      font-size: 20px;
      color: #207f3b;
    }

    .iconInvalid {
      font-size: 20px;
      color: #d8222f;
    }
  }

  .privacy-policy-link {
    font-weight: 500;
    
    &.no-list-recipients {
      margin-top: 100px;

      @media (max-width: 410px) {
        margin-top: 20px;
      }
    }

    &:not(.no-list-recipients) {
      margin-top: 20px;
    }
  }

  .signature-outer {
    width: 100%;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    height: 225px;
    & > button {
      position: absolute;
      bottom: -75px;
      @media (max-width: 410px) {
        width: 100%;
      }
    .signature-inner {
      border: 1px solid #ccc;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #fff;
      overflow: hidden;
    }
  }

`;
